import React, { useContext, useState, useEffect } from "react";
import PendingIcon from "@mui/icons-material/Pending";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { MapContainer } from "react-leaflet/MapContainer";
import { Marker } from "react-leaflet/Marker";
import { Circle } from "react-leaflet/Circle";
import { CircleMarker } from "react-leaflet/CircleMarker";
import { divIcon } from 'leaflet';
import { Popup } from "react-leaflet/Popup";
// import { Tooltip } from "react-leaflet/Tooltip";
import { TileLayer } from "react-leaflet/TileLayer";
import { CanalContext } from "./provider/CanalProvider";
import "./MapView.css";


export default function MapView() {
  const { sales, mapaCirculo, setMapaCirculo, consolidadoRuta, visitas, totales, canalSelected } = useContext(CanalContext);
let arregloVendedores = []
if (canalSelected.vendedores){
arregloVendedores = JSON.parse(canalSelected.vendedores)
}

 const letra = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U"]


  const [newBounds, setNewBounds] = useState([[-35.424557, -71.648537]])
  const [mapa, setMapa] = useState(null);
  const [flag, setFlag] = useState(true);

  // const customIcon = divIcon({ html: "88", iconSize: "auto" });
  //let salesBounds = [[-33.437781, -70.650469]];
  // console.log("14 sales [0]._id",sales[0]._id)
  //const newBounds = sales[0]._id === "1" ? [[-35.424557, -71.648537],[-35.431470, -71.642574] ] : sales.map((e) => [e.lat, e.lng]);
 // const newBounds = sales.map((e) => [e.lat, e.lng]);
  // console.log("###newBounds###", newBounds)
  // useEffect(() => {
  //   setNewBounds(sales.map((e) => [e.lat, e.lng]))
  // }, [sales]);
 
  useEffect(() => {
    if(!flag && visitas.length > 0) {
    //  mapa.fitBounds(consolidadoRuta.map( m=> (m.visita).slice(-1)[0]).map(e=> [e.lat_visita, e.lng_visita] ));
     mapa.fitBounds(visitas.map(e=> [(e.visita.slice(-1)[0]).lat_visita, (e.visita.slice(-1)[0]).lng_visita] ));
    }
    setFlag(false)
  }, [mapa, flag, totales]);

  return (
    <>
      {newBounds ? (
        <MapContainer zoom={18} bounds={newBounds} ref={setMapa}>
          <TileLayer url="https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}" />
          {/* {consolidadoRuta.map(m=> (m.visita).slice(-1)[0]).map((s, index) => ( */}
          {visitas.map((v, index) =>{

            // const pepito = `A${index} `;
            const indiceVendedor = arregloVendedores.findIndex(a=> a == v.codigo);
            const pepito = letra[indiceVendedor];
            // console.log("pepito + indiceVendedor", pepito, indiceVendedor);
    return (
            <Marker 
             key={index} 
            position={[(v.visita.slice(-1)[0]).lat_visita, (v.visita.slice(-1)[0]).lng_visita]}
             icon={divIcon({ html: `<div class="circle ${(v.visita.slice(-1)[0].status).replace(/\s/g, '').toLowerCase()}">${pepito+(v.visita.slice(-1)[0]).secuencia}</div>`, iconSize: "auto", iconAnchor:[15,15] })}
            >
              <Popup><b>{(v.visita.slice(-1)[0]).status}</b><p>{v.rutcliente}</p></Popup>
              {/* <Tooltip permanent>{s.secuencia}</Tooltip> */}
            </Marker>
            
          )

          }

          )
          }
        { mapaCirculo && 
        <CircleMarker center={mapaCirculo} radius={30}  color="red">
        {/* <Popup>Aca popup</Popup> */}
        {/* <Tooltip permanent>Datos del cliente</Tooltip> */}
        </CircleMarker>
        }
        </MapContainer>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Typography variant="h1" component="h2">
            Esperando
          </Typography>
          <PendingIcon sx={{ fontSize: 100 }} />
        </Box>
      )}
    </>
  );
}
